
import { addDays, addHours, format, isPast, isToday, parseISO, setHours, setMinutes, startOfToday } from "date-fns";

export interface OnDemandAvailability {
  prep_time_hours: number;
  cutoff_time: string;
  pickup_window_start: string;
  pickup_window_end: string;
  available_days: string[];
  max_daily_orders?: number;
}

// Parse time string in format "HH:MM" to hours and minutes
export const parseTimeString = (timeString: string): { hours: number, minutes: number } => {
  const [hoursStr, minutesStr] = timeString.split(':');
  return {
    hours: parseInt(hoursStr, 10),
    minutes: parseInt(minutesStr, 10)
  };
};

// Calculate earliest possible pickup date based on prep time, cutoff time, and available days
export const calculateEarliestPickup = (config: OnDemandAvailability): Date => {
  console.log('Calculating earliest pickup with config:', config);
  
  const now = new Date();
  let earliestDate = startOfToday();
  
  // Add prep time hours
  if (config.prep_time_hours) {
    earliestDate = addHours(earliestDate, config.prep_time_hours);
  }
  
  // Check if we've passed today's cutoff time
  if (config.cutoff_time) {
    const { hours, minutes } = parseTimeString(config.cutoff_time);
    const cutoffTime = setHours(setMinutes(startOfToday(), minutes), hours);
    
    if (isPast(cutoffTime)) {
      // If we're past cutoff, add another day
      earliestDate = addDays(earliestDate, 1);
      console.log('Past cutoff time, adding a day');
    }
  }
  
  // Check if the earliest date falls on an available day
  let dayIncrement = 0;
  let maxIterations = 7; // Avoid infinite loop
  
  while (maxIterations > 0) {
    const dayName = format(addDays(earliestDate, dayIncrement), 'EEEE');
    if (config.available_days.includes(dayName)) {
      // Found an available day
      earliestDate = addDays(earliestDate, dayIncrement);
      break;
    }
    dayIncrement++;
    maxIterations--;
  }
  
  console.log('Calculated earliest pickup date:', earliestDate);
  return earliestDate;
};

export const formatAvailabilityForDisplay = (slots: any[]): string => {
  if (!slots || slots.length === 0) return "No availability";
  
  try {
    // Display the next available slot
    const firstSlot = slots[0];
    if (firstSlot.recurring && firstSlot.recurring.days) {
      // For recurring schedules
      const days = firstSlot.recurring.days.join(', ');
      return `Every ${days} at ${firstSlot.startTime}`;
    } else {
      // For specific dates
      const startDate = parseISO(firstSlot.dateRange.from);
      const displayDate = format(startDate, 'MMM d');
      return `${displayDate} at ${firstSlot.startTime}`;
    }
  } catch (error) {
    console.error('Error formatting availability:', error);
    return "Error displaying availability";
  }
};
